import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../../styles';

export default createUseStyles(
  {
    root: {
      backgroundColor: 'rgba(51, 51, 51, 0.40)',
      height: '100vh',
      left: 0,
      position: 'fixed',
      top: 0,
      width: '100vw',
      zIndex: 100,
    },

    iframeContainer: {
      backgroundColor: '#fff',
      borderRadius: 8,
      height: 780,
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'min(100%, 1024px)',

      [mediaQuery(1024)]: {
        height: 600,
      },
    },

    iframe: {
      border: 'none',
      borderRadius: 8,
      height: '100%',
      width: '100%',
    },

    loader: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },

    icon: {
      cursor: 'pointer',
      fill: '#fff',
      position: 'absolute',
      right: 16,
      top: 16,

      [mediaQuery(1024)]: {
        fill: '#000',
      },
    },
  },
  { name: 'LoginPopup' },
);
